import React from "react";
import EditDatePicker from "components/EditDatePicker";
import ButtonDelete from "components/buttons/ButtonDelete";
import Upload from "components/Upload";
import {useTranslation} from "react-i18next";
import EditSelect from "components/selects/EditSelect";
import {certificationsList} from "constants/select.consts";
import {inject, observer} from "mobx-react";

const LicenceForm = inject("store")(
  observer(({store: {organization}, index, remove, licence, setFieldValue}) => {
    const {t} = useTranslation();
    const fileFieldName = `licenses.${index}.Files`;

    return (
      <div className="editBlock_item">
        <div className="editBlock_flex__wrap">
          <EditSelect
            name={`licenses.${index}.name`}
            label={t("NAME")}
            list={certificationsList}
          />
          <EditDatePicker label={t("VALID_UNTIL")} name={`licenses.${index}.validDate`} />
          <Upload
            uploadRequest={organization.licensesUploadFile}
            files={licence.Files}
            onChange={(files) => setFieldValue(fileFieldName, files)}
          />
          <ButtonDelete addClass="editBlock_btn__clean" onClick={() => remove(index)} />
        </div>
      </div>
    );
  })
);

export default LicenceForm;
